import React, { useEffect, useState } from "react";
import axios from "../../API/axios";
import { Link, useParams } from "react-router-dom";
import moment from "moment";
import error from "../../assets/images/Not-Found.png";


const InstitutionProfile = () => {
	const userUID = localStorage.getItem("userUID");
	const userType = localStorage.getItem("userType");
	console.log("userID====>", userUID);

	//   const { InsUseId } = useParams(); 
	const { userUid: InsUseId } = useParams();
	const [profileData, setProfileData] = useState("");
	const [loading, setLoading] = useState(true); // New state for loading
	const [isError, setIsError] = useState(false);




	const GetProfile = async () => {
		try {
			const res = await axios.get(
				`/Institute/GetProfile?UID=${userType === "Company" || userType === "Recruiter" ? InsUseId : userUID
				}`
			);
			setProfileData(res.data.responseData);
			console.log("institutedetails", res);
			setLoading(false);

		} catch (error) {
			setIsError(true);

			console.log("error", error);

		}
	};

	useEffect(() => {
		GetProfile();
	}, []);

	return (
		<>
			{loading ? (
				<div className="mt-6 d-flex justify-content-center">
					<p>Loading...</p>
				</div>
			) : isError ? (
				<div className="mt-6 d-flex justify-content-center">
					<img src={error} alt="404 Not Found" width={300} />
				</div>
			) : (
				<>
					<div className="profile-resume-main-container pt-3">
						<div className="profile-resume-heading-cont ">
							<h4 className="orange-title">
								<span className="orange-box me-2"></span>
								Profile
							</h4>
						</div>

						<div className="profile-resume-userinfo mb-3">
							<div className="row pt-4 pb-4 align-center">
								<div className="col-md-3 col-lg-2">
									<div className="profile-resume-image d-flex justify-content-center">
										<img
											src={profileData.logoImage}
											alt=""
											srcset=""
											width={"100px"}
											style={{ borderRadius: "50%", height: "100px" }}
										/>
									</div>
								</div>
								<div className="col-md-6 col-lg-6">
									<div className="profile-resume-designation f-14 f-600">
										{profileData.tagline === null ? (
											""
										) : (
											<div className="profile-resume-designation f-14 f-600">
												{profileData.tagline}
											</div>
										)}
									</div>
									<div className="d-flex align-items-center mb-1 Main-resume-username">
										<div className="profile-resume-username me-2">
											{profileData.name}
										</div>
									</div>
									<div className="d-flex Resume-Skills-Country-Mobile">
										{profileData.cityName === null ? (
											""
										) : (
											<>
												<div className="profile-resume-country d-flex align-items-center">
													<div className="profile-resume-country-icon d-flex  align-item-center me-3 f-18  f-400">
														<span class="icon-map-pin me-2"></span>
														{profileData.cityName}
													</div>
												</div>
											</>
										)}
									</div>
								</div>
								<div className="col-md-3 col-lg-3"></div>
							</div>
						</div>

						<div className="row">
							<div className="col-lg-4">
								<div className="cv-form-details po-sticky job-sg single-stick email-cv-form-details profile-resume-userinfo ">
									<ul className="list-infor email-list-infor p-0 mb-0">
										{/* {profileData.email === null ? "" : ( */}
										<li className="only-for-email mb-0 pb-0">
											<div className="category Notification-Text">Email</div>
											<div className="detail">
												{/* {profileData.email || "N.A."} */}
												<a href={`mailto:${profileData.email}`}
													onClick={(e) => {
														if (!profileData.email) {
															e.preventDefault();
															alert("Email is not available!");
														}
													}}
												>
													{profileData.email || "N.A"}
												</a>
											</div>
										</li>
										{/* )} */}

										{/* {profileData.contactNo === null ? "" : ( */}
										<li className="only-for-email mb-0 pb-0">
											<div className="category Notification-Text">
												{" "}
												Phone Number
											</div>
											<div className="detail">
												{/* {profileData.contactNo || "N.A."} */}
												<a href={`tel:${profileData.contactNo}`}
													onClick={(e) => {
														if (!profileData.contactNo) {
															e.preventDefault();
															alert("Email is not available!");
														}
													}}
												>
													{profileData.contactNo || "N.A"}
												</a>
											</div>
										</li>
										{/* )} */}

										{/* {profileData.website === null ? "" : ( */}
										<li className="only-for-email mb-0 pb-0">
											<div className="category Notification-Text">Website</div>
											<div className="detail">
												{/* {profileData.website || "N.A."} */}
												<a
													href={profileData.website ? profileData.website.startsWith("http") ? profileData.website : `https://${profileData.website}` : "#"}
													onClick={(e) => {
														if (!profileData.website) {
															e.preventDefault();
															alert("Website is not available!");
														}
													}}
													target="_blank"
													rel="noopener noreferrer"
												>
													{profileData.website || "N.A."}
												</a>
											</div>
										</li>
										{/* )} */}

										{/* {profileData.startedDate === null ? "" : ( */}
										<li className="only-for-email mb-0 pb-0">
											<div className="category Notification-Text">Start Date</div>
											<div className="detail">
												{moment(profileData.startedDate).format("DD MMM YYYY") ||
													"N.A."}
											</div>
										</li>
										{/* )} */}
									</ul>
								</div>
							</div>

							{profileData.about === null ? (
								""
							) : (
								<>
									<div className="col-lg-8 Aboutme-Container-Profile">
										<div className="profile-resume-parent-cont p-4 rounded-3">
											{profileData.about === null ? (
												""
											) : (
												<div className="profile-resume-about">
													<div className="profile-resume-about-heading f-20  f-800 mb-1">
														About
													</div>

													<div className="profile-resume-about-info">
														<p className="f-16 f-400">{profileData.about}</p>
														<p className="f-16 f-400"></p>
													</div>
												</div>
											)}
											{profileData.description === null ? (
												""
											) : (
												<div className="profile-resume-about-info">
													<div className="profile-resume-about-heading f-20  f-800 mb-1">
														Description
													</div>
													<p className="f-16 f-400">{profileData.description}</p>
												</div>
											)}
										</div>
									</div>
								</>
							)}
						</div>
					</div>
				</>
			)}

		</>
	);
};

export default InstitutionProfile;
